"use client";

import React from "react";
import { Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Card, CardContent } from "@/components/ui/card";
const testimonials = [{
  author: "Sophie M.",
  quote: "Linda schafft eine Atmosphäre, in der man sich sofort geborgen fühlt. Meine Haut strahlt nach dem BEWEI-Konzept wie nie zuvor.",
  position: "Treue Kundin"
}, {
  author: "Marc R.",
  quote: "Die Lymphdrainage bei Bodyconcept Allendorf ist pure Entspannung mit sichtbaren Ergebnissen. Ein absolutes Muss für das Wohlbefinden.",
  position: "Wellness-Gast"
}];
export default function WordFromTheField() {
  return <section data-section-id="229612" id="kundenstimmen" className="relative text-foreground py-16 overflow-hidden !bg-[rgba(189,255,248,1)] md:py-24">
      {}
      <div className="absolute inset-0 z-0 pointer-events-none">
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642411/img/muddy_jobsite_background.png)] bg-cover bg-center blur-3xl scale-105 opacity-0"></div>
        <div className="absolute inset-0 bg-secondary/80 backdrop-blur-[4px]"></div>
      </div>

      <div className="container relative z-10 mx-auto px-4 !h-[400px]">
        <div className="text-center mb-16 md:mb-24">
          <h2 className="font-default uppercase tracking-tighter !text-5xl !text-[rgba(59,168,156,1)] !font-semibold">Echte Erfahrungen<span className="text-accent-foreground !font-normal" data-ast-id="f:/src/pages/SolutionsSubpages/sections/WordFromTheField.tsx|sig:16dmo9" data-ast-start="1497" data-ast-end="1558" contenteditable="false" style={{}}></span></h2>
          
        </div>

        <Carousel opts={{
        loop: true,
        align: "center"
      }} className="w-full max-w-5xl mx-auto">
          <CarouselContent>
            {testimonials.map((testimonial, i) => <CarouselItem key={i} data-index={i}>
                <Card className="text-card-foreground flex flex-col gap-6 rounded-xl py-6 bg-transparent border-none shadow-none !h-[300px]">
                  <CardContent className="flex flex-col items-center text-center p-4 md:p-12">
                    <Quote className="size-10 md:size-12 text-accent-foreground mb-8 opacity-40" />
                    <p className="font-default italic font-medium leading-tight mb-12 text-foreground max-w-4xl mx-auto tracking-tight !text-3xl whitespace-nowrap">
                      "{testimonial.quote}"
                    </p>
                    <div className="flex flex-col items-center tracking-widest">
                      <span className="font-default font-semibold text-lg md:text-xl text-primary mb-1">
                        {testimonial.author}
                      </span>
                      
                    </div>
                  </CardContent>
                </Card>
              </CarouselItem>)}
          </CarouselContent>
          
          {}
          <div className="flex items-center justify-center gap-6 mt-8 md:hidden">
            <CarouselPrevious className="relative inset-auto transform-none rounded-full border border-border bg-background hover:bg-accent hover:text-accent-foreground hover:border-accent size-10 transition-colors" />
            <CarouselNext className="relative inset-auto transform-none rounded-full border border-border bg-background hover:bg-accent hover:text-accent-foreground hover:border-accent size-10 transition-colors" />
          </div>
        </Carousel>
      </div>
    </section>;
}